var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "ul",
    {
      staticClass: "widget-list widget-links sidebar-views",
    },
    [
      _c(
        "li",
        {
          class: {
            active: _vm.tableView,
          },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "#",
              },
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.setTableView.apply(null, arguments)
                },
              },
            },
            [_c("translate", [_vm._v("Tabellarische Ansicht")])],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: {
            active: _vm.tilesView,
          },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "#",
              },
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.setTilesView.apply(null, arguments)
                },
              },
            },
            [_c("translate", [_vm._v("Kachelansicht")])],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }